// Common
import { callQBookingApi } from "./common";

// Utils
import { get } from "Utils/HTTPMethods";

export const getAvailableAppointmentsCount = async () => {
  return callQBookingApi(get, "/availableAppointmentsCount");
};
